export const recommendationsDistanceInKm = 2;

export const vendorRecommendationsDistanceInKm = 2;

export const MULTI_LEAD_ESTIMATE_PRICE_DELAY = 2000;

export const REVEALED_PRICE_ESTIMATED_UPPER_FACTOR = 1.1;

export const REVEALED_PRICE_ESTIMATED_LOWER_FACTOR = 1;
export const recommendationsDistanceInKm = 2;

export const vendorRecommendationsDistanceInKm = 2;

export const MULTI_LEAD_ESTIMATE_PRICE_DELAY = 2000;

export const REVEALED_PRICE_ESTIMATED_UPPER_FACTOR = 1.1;

export const REVEALED_PRICE_ESTIMATED_LOWER_FACTOR = 1;
